import React, { useContext } from 'react';

import './style/contract.scss';
import { Checkbox, Col, Form } from 'antd';
import { CheckoutContext } from '../shared/CheckoutProvider';

import config from '../../../config';

const PROMOTION_MIN_VALUE = 1000;
const PROMOTION_REGULATION_URL =
  'https://arquivos.academiarafaeltoro.com.br/uploads/Academia+Rafael+Toro+-+Regulamento+autorizado.pdf';

const Contract = ({ columns = 24 }) => {
  const { values, setContract, setContractPrivacity, setPromotion, course } = useContext(CheckoutContext);

  const showPromotion = Number(course.valor_curso) >= PROMOTION_MIN_VALUE;

  return (
    <>
    <Col className="gutter-row box-contract payment" xs={24} md={columns}>
      <Form.Item className="input-form from-terms" name="contract" valuePropName="contract">
        <Checkbox
          checked={values.contract}
          className="input-contract"
          value={values.contract}
          onChange={setContract}
        >
          Li e aceito os &nbsp;
          <a
            href={config.s3Url + course.contrato}
            className="btn-accept-the-contract"
            target="_blank"
            rel="noopener noreferrer"
          >
            termos de serviço
          </a>
        </Checkbox>
      </Form.Item>
    </Col>
    <Col className="gutter-row box-contract" xs={24} md={columns}>
      <Form.Item className="input-form" name="contract" valuePropName="contract">
        <Checkbox
          checked={values.contractPrivacity}
          className="input-contract"
          value={values.contractPrivacity}
          onChange={setContractPrivacity}
        >
          Li e aceito os &nbsp;
          <a
            href='https://www.academiarafaeltoro.com.br/politica-de-privacidade/'
            className="btn-accept-the-contract"
            target="_blank"
            rel="noopener noreferrer"
          >
            política de privacidade
          </a>
        </Checkbox>
      </Form.Item>
    </Col>
    {showPromotion && (
      <Col className="gutter-row box-contract box-promotion" xs={24} md={columns}>
        <Form.Item className="input-form" name="promo_opt_in" valuePropName="promo_opt_in">
          <Checkbox
            checked={values.promo_opt_in}
            className="input-contract"
            value={values.promo_opt_in}
            onChange={setPromotion}
          >
            Quero participar da promoção De Carona com Toro e concorrer a 1 prêmio de R$
            150.000,00 em cartão com crédito, sem função de saque ou transferência, conforme
            o &nbsp;
            <a
              href={PROMOTION_REGULATION_URL}
              className="btn-accept-the-contract"
              target="_blank"
              rel="noopener noreferrer"
            >
              regulamento
            </a>
          </Checkbox>
        </Form.Item>
        <p className="promotion-disclosure">
          Consulte o regulamento e o número do certificado de autorização no site
          carona.academiarafaeltoro.com.br. Certificado de Autorização SPA/ME N°
          04.051074/2026.
        </p>
      </Col>
    )}
    </>
  );
};

export default Contract;
